import { QueryFactory } from "../../../../Common";
export const QGetLaunchParams = QueryFactory("GetLaunchParams");
//# sourceMappingURL=QGetLaunchParams.js.map